export enum __DepositMethodsEnum {
    direct,
    cashInDeposit,
    cardToCard,
    offlineDeposit,
}
